import { useEffect, useRef, useState } from 'react'
import { getDocument } from 'pdfjs-dist/legacy/build/pdf.mjs'

import {
  getPdfViewerDocumentInitParameters,
  getPdfViewerDocumentUrl,
} from './usePdfViewer.utils'

export function usePdfViewerDocument({
  file,
  pdfViewerRef,
  onReplaceDocument,
}) {
  const [pdfDocument, setPdfDocument] = useState(null)
  const [isDocumentLoading, setDocumentLoading] = useState(false)
  const [hasLoadError, setLoadError] = useState(false)

  const loadingTaskRef = useRef(null)

  const documentUrl = getPdfViewerDocumentUrl(file)

  useEffect(() => {
    const pdfViewer = pdfViewerRef.current

    if (documentUrl && pdfViewer) {
      setDocumentLoading(true)
      setLoadError(false)

      if (loadingTaskRef.current) {
        pdfViewer.setDocument(null)
        pdfViewer.linkService.setDocument(null)
        loadingTaskRef.current.destroy()

        setPdfDocument(null)
        onReplaceDocument()
      }

      const loadingTask = getDocument(
        getPdfViewerDocumentInitParameters(documentUrl)
      )

      loadingTaskRef.current = loadingTask

      loadingTask.promise
        .then(loadedDocument => {
          if (loadingTaskRef.current === loadingTask) {
            pdfViewer.setDocument(loadedDocument)
            pdfViewer.linkService.setDocument(loadedDocument)
            setPdfDocument(loadedDocument)
          }
        })
        .catch(error => {
          if (loadingTaskRef.current === loadingTask) {
            setDocumentLoading(false)
            setLoadError(true)

            console.error('PdfViewer: failed to load document', error)
          }
        })
    }
  }, [documentUrl])

  useEffect(() => {
    return () => {
      loadingTaskRef.current?.destroy()
      loadingTaskRef.current = null
    }
  }, [])

  // the file is on screen once pdf.js paints the first page, not once it loads
  function handlePageRendered() {
    setDocumentLoading(false)
  }

  return {
    hasDocumentLoadError: hasLoadError,
    isDocumentLoading,
    pdfDocument,
    onPageRendered: handlePageRendered,
  }
}
